import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const getNewFileData = async (productId) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getfiledata&companyid=${user.companyid}&productid=${productId}`,
  );

  return response.data;
};

const useGetNewFileDataQuery = (productId, options) => {
  return useQuery({
    queryKey: ["newFileData", productId],
    queryFn: () => getNewFileData(productId),
    ...options,
  });
};

const uploadNewTestFile = async ({ file, fileName, productId }) => {
  const user = getUserDetails();
  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=uploadTestDataFile&companyid=${user.companyid}&prodid=${productId}&fileName=${fileName}`,
    file,
    {
      headers: {
        "content-type": file.type,
      },
    },
  );

  return response.data;
};
const useUploadNewTestFileQuery = (options) => {
  return useMutation({
    mutationFn: ({ file, fileName, productId }) => uploadNewTestFile({ file, fileName, productId }),
    ...options,
  });
};

export { useGetNewFileDataQuery, useUploadNewTestFileQuery };
